<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push('/person-add')"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
        <vs-button
          icon-pack="feather"
          icon="icon-map"
          class="p-3 mb-4 mr-4 "
          @click="$router.push('/people/reseller-map')"
          >Map of Clients
        </vs-button>
        <vs-button
          v-if="displayExport"
          icon-pack="feather"
          color="warning"
          icon="icon-mail"
          class="p-3 mb-4 mr-4 "
          @click="$router.push('/mailings')"
          >Mailings
        </vs-button>
        <vs-button
          v-if="displayExport"
          icon-pack="feather"
          color="success"
          icon="icon-target"
          class="p-3 mb-4 mr-4 "
          @click="$router.push('/people/potential-interest')"
          >Potential interest
        </vs-button>
        <vs-button
          v-if="displayExport"
          icon-pack="feather"
          type="border"
          color="warning"
          icon="icon-activity"
          class="p-3 mb-4 mr-4 "
          @click="$router.push('/people/cleandb')"
          >Clean Database
        </vs-button>
    </div>
    <div class="vx-card p-6" style="position: relative;">
      <transition name="fade">
        <div v-if="isRestoringFilters" class="filter-loading-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.5); z-index: 10; display: flex; align-items: center; justify-content: center; border-radius: 8px; pointer-events: none;">
          <div style="display: flex; align-items: center; gap: 8px; color: #7367f0; opacity: 0.8;">
            <div class="spinner" style="width: 16px; height: 16px; border: 2px solid rgba(115, 103, 240, 0.2); border-top-color: #7367f0; border-radius: 50%; animation: spin 0.6s linear infinite;"></div>
            <span style="font-size: 12px; font-weight: 500;">Restoring filters...</span>
          </div>
        </div>
      </transition>
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <vs-button v-if="displayExport != false" class="mb-4 md:mb-0 mr-2" @click="exportToXLSX()">Export as XLSX</vs-button>
        <vs-button type="border" color="primary" class="mb-4 md:mb-0" @click="clearAllFilters" icon-pack="feather" icon="icon-x">
          Clear Filters
        </vs-button>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @grid-ready="onGridReady"
      ></ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import modulePersonList from "@/store/people/modulePersonList.js";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import * as XLSX from "xlsx";
import { SIGNALS as CREDIT_SIGNALS } from "@/mixins/creditRating";

const creditFlagLabels = (raw) =>
  !raw
    ? ""
    : String(raw)
        .split(",")
        .map((x) => x.trim())
        .filter((x) => CREDIT_SIGNALS[x])
        .map((x) => CREDIT_SIGNALS[x].label)
        .join(", ");

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      displayExport: false,
      searchQuery: "",
      gridApi: null,
      gridOptions: {},
      filterChangedListener: null,
      isRestoringFilters: false,
      hasRestoredFilters: false,
      isSavingFilters: false,
      filterChangeCounter: 0, // Pour forcer la réactivité du computed hasActiveFilters
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          filter: true,
          order: "ASC",
          width: 270,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Category",
          valueGetter: function (params) {


            let jt = null
            if (params.data.jobtitle)
            {
              if (!params.data.isdatestopofcontractok && params.data.isdatestartofcontractok >=0)
              {
                jt = "Employee"
              }
              else if (!params.data.isdatestopofcontractok && params.data.isdatestartofcontractok < 0)
              {
                jt = "Future Employee"
              }
              else if (params.data.isdatestopofcontractok && params.data.isdatestartofcontractok < 0)
              {
                jt = "Future Employee"
              }
              else if (params.data.isdatestopofcontractok >= 0 && params.data.isdatestartofcontractok <= 0)
              {
                jt = "Employee"
              }
              else if (params.data.isdatestopofcontractok < 0 && params.data.isdatestartofcontractok > 0)
              {
                jt = "Ex-Employee"
              }
              else jt = "Employee"
            }
            if (params.data.isbroker)
            {
            if (jt && params.data.category) return jt+","+params.data.category+",Reseller/Broker";
            else if (jt && !params.data.category) return jt+",Reseller/Broker";
            else if (!jt && params.data.category) return params.data.category+",Reseller/Broker";
            else return "Broker";
            }
            else if (params.data.isreseller)
            {
            if (jt && params.data.category) return jt+","+params.data.category+",Reseller";
            else if (jt && !params.data.category) return jt+",Reseller";
            else if (!jt && params.data.category) return params.data.category+",Reseller";
            else return "Reseller";
            }
            else
            {
            if (jt && params.data.category) return jt+","+params.data.category;
            else if (jt && !params.data.category) return jt;
            else if (!jt && params.data.category) return params.data.category;
            else return "not applicable";
            }
          },
          filter: true,
          width: 130,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "Reliability",
          valueGetter: function (params) {
            if (params.data.reliability === 5) return "5/5";
            else if (params.data.reliability === 4) return "4/5";
            else if (params.data.reliability === 3) return "3/5";
            else if (params.data.reliability === 2) return "2/5";
            else if (params.data.reliability === 1) return "1/5";
            else if (params.data.reliability === 0) return "0/5";
            else return "-";
          },
          filter: true,
          width: 80,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          // Cote credit : risque de paiement, calcule depuis l'historique de
          // facturation. A ne pas confondre avec la colonne Reliability juste
          // avant, qui est le ressenti commercial saisi a la main.
          headerName: "Credit",
          colId: "credit_cote",
          valueGetter: function (params) {
            const c = params.data.credit_cote;
            // Une fiche jamais analysee n'est pas une bonne fiche, c'est une
            // fiche inconnue. Elle ne doit jamais s'afficher comme un bon score.
            if (c === null || c === undefined) return "Not rated";
            return c + "/5";
          },
          filter: true,
          width: 90,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          // Les libelles bruts stockes en base ne parlent qu'au code : la
          // grille affiche la version lisible, la meme que la fiche contact.
          headerName: "Credit note",
          colId: "credit_flags",
          valueGetter: (params) =>
            creditFlagLabels(params.data.credit_flags),
          filter: true,
          width: 190,
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 150,
        },
        {
          headerName: "Phone",
          field: "phone",
          filter: true,
          width: 180,
        },
        {
          headerName: "Country",
          field: "country",
          filter: true,
          width: 110,
        },
        {
          headerName: "Language",
          field: "language",
          filter: true,
          width: 110,
        },
        {
          headerName: "Source",
          field: "source",
          filter: true,
          width: 150,
        },
        {
          headerName: "Broker",
          field: "broker_name",
          filter: true,
          width: 110,
        },
        {
          headerName: "Last interaction",
          field: "last_interaction",
          filter: true,
          width: 130,
        },
        {
          headerName: "Revenues (EUR)",
          field: "ca_eur",
          filter: true,
          width: 130,
          type: "numericColumn",
        },
        {
          headerName: "Type",
          field: "client_type",
          filter: true,
          width: 130,
          type: "numericColumn",
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 120,
          cellRendererFramework: "CellRendererActions",
        },
      ],
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    usersData: {
      handler(newVal) {
        console.log('[UserList] watch usersData:', {
          hasData: !!(newVal && newVal.length > 0),
          dataLength: newVal ? newVal.length : 0,
          hasGridApi: !!this.gridApi,
          hasRestoredFilters: this.hasRestoredFilters
        });

        // Si les données sont chargées et qu'on n'a pas encore restauré, le faire
        // On attend que gridApi soit disponible
        if (newVal && newVal.length > 0 && this.gridApi && !this.hasRestoredFilters) {
          const savedFilterModel = sessionStorage.getItem('peopleList_filterModel');
          const savedSearchQuery = sessionStorage.getItem('peopleList_searchQuery');
          const savedCurrentPage = sessionStorage.getItem('peopleList_currentPage');

          console.log('[UserList] watch usersData: checking saved filters', {
            savedFilterModel: !!savedFilterModel,
            savedSearchQuery: !!savedSearchQuery,
            savedCurrentPage: !!savedCurrentPage
          });

          // Si on a des filtres sauvegardés, les restaurer
          if (savedFilterModel || savedSearchQuery || savedCurrentPage) {
            console.log('[UserList] watch usersData: found saved filters, will restore');
            // Utiliser un flag pour éviter les restaurations multiples
            this.hasRestoredFilters = true;
            setTimeout(() => {
              this.restoreFilterState();
            }, 300);
          } else {
            console.log('[UserList] watch usersData: no saved filters to restore');
            // Pas de filtres à restaurer
            this.hasRestoredFilters = true;
          }
        } else {
          if (!newVal || newVal.length === 0) {
            console.log('[UserList] watch usersData: no data yet');
          } else if (!this.gridApi) {
            console.log('[UserList] watch usersData: gridApi not ready yet');
          } else if (this.hasRestoredFilters) {
            console.log('[UserList] watch usersData: already restored, skipping');
          }
        }
      },
      immediate: false // Ne pas exécuter immédiatement, attendre que les données changent
    }
  },
  computed: {
    usersData() {
      return this.$store.state.peopleList.people;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
        this.saveFilterState();
      },
    },
    hasActiveFilters() {
      // Utiliser filterChangeCounter pour forcer la réactivité
      const _ = this.filterChangeCounter;
      if (!this.gridApi) return false;
      const filterModel = this.gridApi.getFilterModel();
      const hasColumnFilters = filterModel && Object.keys(filterModel).length > 0;
      const hasSearchFilter = this.searchQuery && this.searchQuery.trim() !== '';
      return hasColumnFilters || hasSearchFilter;
    },
  },
  methods: {
    onGridReady(params) {
      console.log('[UserList] onGridReady: grid is ready');
      this.gridApi = params.api;
      this.hasRestoredFilters = false; // Réinitialiser le flag

      // Écouter les changements de filtres pour les sauvegarder
      this.filterChangedListener = () => {
        // Incrémenter le compteur pour forcer la réactivité du computed hasActiveFilters
        this.filterChangeCounter++;

        // Ne pas sauvegarder si on est en train de restaurer
        if (this.isRestoringFilters) {
          console.log('[UserList] filterChanged listener: skipping save because restoring');
          return;
        }
        // Ne pas sauvegarder si on n'a pas encore restauré (évite les sauvegardes lors de l'initialisation)
        if (!this.hasRestoredFilters) {
          console.log('[UserList] filterChanged listener: skipping save because not yet restored');
          return;
        }
        // Petit délai pour que ag-grid mette à jour le filterModel après le changement
        setTimeout(() => {
          this.saveFilterState();
        }, 100);
      };
      this.gridApi.addEventListener('filterChanged', this.filterChangedListener);
      console.log('[UserList] onGridReady: filterChanged listener added');

      // Si les données sont déjà chargées, essayer de restaurer
      if (this.usersData && this.usersData.length > 0) {
        console.log('[UserList] onGridReady: data already loaded, checking for saved filters');
        const savedFilterModel = sessionStorage.getItem('peopleList_filterModel');
        const savedSearchQuery = sessionStorage.getItem('peopleList_searchQuery');
        const savedCurrentPage = sessionStorage.getItem('peopleList_currentPage');

        if (savedFilterModel || savedSearchQuery || savedCurrentPage) {
          console.log('[UserList] onGridReady: found saved filters, will restore');
          setTimeout(() => {
            this.restoreFilterState();
            this.hasRestoredFilters = true;
          }, 500);
        } else {
          console.log('[UserList] onGridReady: no saved filters found');
        }
      } else {
        console.log('[UserList] onGridReady: data not loaded yet, will wait for watcher');
      }
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
      this.saveFilterState();
    },
    resetColFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };
      this.$refs.filterCard.removeRefreshAnimation();
      this.saveFilterState();
    },
    updateSearchQuery(val) {
      console.log('[UserList] updateSearchQuery:', val);
      this.gridApi.setQuickFilter(val);
      // Forcer la mise à jour du computed
      this.filterChangeCounter++;
      this.saveFilterState();
    },
    saveFilterState() {
      if (!this.gridApi) {
        console.log('[UserList] saveFilterState: gridApi not available');
        return;
      }

      // Ne pas sauvegarder si on est en train de restaurer les filtres
      if (this.isRestoringFilters) {
        console.log('[UserList] saveFilterState: skipping save because we are restoring filters');
        return;
      }

      // Ne pas sauvegarder si on n'a pas encore restauré (évite les sauvegardes lors de l'initialisation)
      if (!this.hasRestoredFilters) {
        console.log('[UserList] saveFilterState: skipping save because not yet restored');
        return;
      }

      // Éviter les sauvegardes multiples simultanées
      if (this.isSavingFilters) {
        console.log('[UserList] saveFilterState: already saving, skipping');
        return;
      }

      this.isSavingFilters = true;

      // Récupérer directement le filterModel (ag-grid le met à jour automatiquement)
      const filterModel = this.gridApi.getFilterModel();
      const filterModelStr = JSON.stringify(filterModel);
      const currentPage = this.gridApi.paginationGetCurrentPage();

      console.log('[UserList] saveFilterState:', {
        filterModel: filterModel,
        searchQuery: this.searchQuery,
        currentPage: currentPage,
        filterModelStr: filterModelStr,
        isRestoringFilters: this.isRestoringFilters,
        hasRestoredFilters: this.hasRestoredFilters,
        filterModelKeys: filterModel ? Object.keys(filterModel) : []
      });

      sessionStorage.setItem('peopleList_filterModel', filterModelStr);
      sessionStorage.setItem('peopleList_searchQuery', this.searchQuery || '');
      sessionStorage.setItem('peopleList_currentPage', currentPage.toString());

      // Réinitialiser le flag après la sauvegarde
      this.isSavingFilters = false;
    },
    restoreFilterState() {
      if (!this.gridApi) {
        console.log('[UserList] restoreFilterState: gridApi not available');
        return;
      }

      const savedFilterModel = sessionStorage.getItem('peopleList_filterModel');
      const savedSearchQuery = sessionStorage.getItem('peopleList_searchQuery');
      const savedCurrentPage = sessionStorage.getItem('peopleList_currentPage');

      console.log('[UserList] restoreFilterState: checking saved state', {
        savedFilterModel: savedFilterModel,
        savedSearchQuery: savedSearchQuery,
        savedCurrentPage: savedCurrentPage,
        hasRestoredFilters: this.hasRestoredFilters
      });

      if (!savedFilterModel && !savedSearchQuery && !savedCurrentPage) {
        console.log('[UserList] restoreFilterState: no saved state found, skipping');
        return;
      }

      console.log('[UserList] restoreFilterState: starting restoration');
      this.isRestoringFilters = true;

      // Attendre que le grid soit complètement prêt et que les données soient chargées
      this.$nextTick(() => {
        // Attendre un peu plus pour que ag-grid soit complètement initialisé
        setTimeout(() => {
          // Restaurer la recherche d'abord
          if (savedSearchQuery) {
            console.log('[UserList] restoreFilterState: restoring search query:', savedSearchQuery);
            this.searchQuery = savedSearchQuery;
            this.gridApi.setQuickFilter(savedSearchQuery);
          }

          // Restaurer les filtres de colonnes
          if (savedFilterModel && savedFilterModel !== '{}' && savedFilterModel !== 'null') {
            try {
              const filterModel = JSON.parse(savedFilterModel);
              if (filterModel && Object.keys(filterModel).length > 0) {
                console.log('[UserList] restoreFilterState: restoring filter model:', filterModel);
                // Désactiver temporairement le listener pour éviter les sauvegardes pendant la restauration
                if (this.filterChangedListener) {
                  this.gridApi.removeEventListener('filterChanged', this.filterChangedListener);
                }
                this.gridApi.setFilterModel(filterModel);
                this.gridApi.onFilterChanged();
                // Réactiver le listener après un délai
                setTimeout(() => {
                  if (this.filterChangedListener) {
                    this.gridApi.addEventListener('filterChanged', this.filterChangedListener);
                  }
                }, 300);
              } else {
                console.log('[UserList] restoreFilterState: filter model is empty');
              }
            } catch (e) {
              console.error('[UserList] restoreFilterState: Error restoring filter model:', e);
            }
          } else {
            console.log('[UserList] restoreFilterState: no filter model to restore');
          }

          // Restaurer la page en dernier
          if (savedCurrentPage) {
            const page = parseInt(savedCurrentPage, 10);
            console.log('[UserList] restoreFilterState: restoring page:', page);
            // Attendre un peu avant de changer de page pour que les filtres soient appliqués
            setTimeout(() => {
              this.gridApi.paginationGoToPage(page);
              setTimeout(() => {
                console.log('[UserList] restoreFilterState: restoration complete');
                // Attendre encore un peu avant de réactiver les sauvegardes
                setTimeout(() => {
                  this.isRestoringFilters = false;
                }, 300);
              }, 200);
            }, 100);
          } else {
            console.log('[UserList] restoreFilterState: no page to restore');
            setTimeout(() => {
              console.log('[UserList] restoreFilterState: restoration complete');
              // Attendre encore un peu avant de réactiver les sauvegardes
              setTimeout(() => {
                this.isRestoringFilters = false;
              }, 300);
            }, 200);
          }
        }, 100);
      });
    },
    clearFilterState() {
      sessionStorage.removeItem('peopleList_filterModel');
      sessionStorage.removeItem('peopleList_searchQuery');
      sessionStorage.removeItem('peopleList_currentPage');
    },
    clearAllFilters() {
      // Réinitialiser tous les filtres
      if (this.gridApi) {
        this.gridApi.setFilterModel(null);
        this.gridApi.setQuickFilter('');
        this.searchQuery = '';
        this.gridApi.onFilterChanged();
        this.clearFilterState();
        console.log('[UserList] clearAllFilters: all filters cleared');
      }
    },
    exportToXLSX() {
      if (!this.gridApi) {
        this.$vs.notify({
          title: "Error",
          text: "Grid is not ready yet",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      // Récupérer toutes les colonnes sauf "Actions"
      const columnsToExport = this.columnDefs.filter(col => col.headerName !== "Actions");
      const headers = columnsToExport.map(col => col.headerName);

      // Récupérer toutes les lignes filtrées
      const rows = [];
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (node.data) {
          const row = [];
          columnsToExport.forEach(colDef => {
            let value = "";
            // Si la colonne a un valueGetter, l'utiliser
            if (colDef.valueGetter) {
              const params = {
                data: node.data,
                node: node,
                api: this.gridApi,
                columnApi: this.gridApi.columnApi,
                getValue: (field) => node.data[field],
                colDef: colDef
              };
              value = colDef.valueGetter(params);
            } else if (colDef.field) {
              // Sinon, utiliser le field directement
              value = node.data[colDef.field];
            }
            row.push(value !== null && value !== undefined ? value : "");
          });
          rows.push(row);
        }
      });

      if (rows.length === 0) {
        this.$vs.notify({
          title: "No Data",
          text: "No data to export",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right",
        });
        return;
      }

      // Créer le tableau avec les en-têtes et les données
      const data = [headers, ...rows];

      // Créer la feuille de calcul
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // Créer le workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "People");

      // Générer le nom de fichier avec la date
      const date = new Date();
      const dateStr = date.toISOString().split('T')[0]; // Format YYYY-MM-DD
      const filename = `people_export_${dateStr}.xlsx`;

      // Télécharger le fichier
      XLSX.writeFile(workbook, filename);
    },
  },
  mounted() {
    // Le gridApi sera initialisé dans onGridReady
    // On garde cette ligne pour compatibilité mais onGridReady sera appelé après
    if (this.gridOptions.api) {
      this.gridApi = this.gridOptions.api;
    }
  },
  created() {
    console.log('[UserList] created: component created');

    // Réinitialiser le flag de restauration
    this.hasRestoredFilters = false;

    // Vérifier d'où on vient et supprimer les filtres si nécessaire
    const previousRoute = sessionStorage.getItem('peopleList_previousRoute');
    console.log('[UserList] created: previousRoute from sessionStorage:', previousRoute);

    if (previousRoute && previousRoute !== '') {
      // Liste des patterns qui indiquent qu'on vient d'une page de vue/détail
      const wasViewPage = previousRoute.includes('/person/') ||
                          previousRoute.startsWith('/person/') ||
                          previousRoute.includes('/quotation/') ||
                          previousRoute.includes('/transport/') ||
                          previousRoute.includes('/reception/') ||
                          previousRoute.includes('/purchase/') ||
                          previousRoute.includes('/production/') ||
                          previousRoute.includes('/sale/') ||
                          previousRoute.includes('/inventory/') ||
                          previousRoute.includes('/outlay/') ||
                          previousRoute.includes('-edit/') ||
                          previousRoute.includes('-view/') ||
                          previousRoute.includes('View') ||
                          previousRoute.includes('/broker/person/') ||
                          previousRoute.includes('/broker/quotation/') ||
                          previousRoute.includes('/broker/invoice/');

      console.log('[UserList] created: wasViewPage?', wasViewPage, 'previousRoute:', previousRoute);

      // Si on ne vient PAS d'une View, supprimer les filtres
      // On garde les filtres seulement si :
      // 1. On vient d'une page de vue (UserView, etc.)
      // 2. On vient de la même page (refresh/reload)
      const isSamePage = previousRoute === this.$route.path || previousRoute === '/people/people-list';

      if (!wasViewPage && !isSamePage) {
        console.log('[UserList] created: NOT from view page and NOT same page, clearing filters');
        console.log('[UserList] created: previousRoute:', previousRoute, 'currentRoute:', this.$route.path);
        sessionStorage.removeItem('peopleList_filterModel');
        sessionStorage.removeItem('peopleList_searchQuery');
        sessionStorage.removeItem('peopleList_currentPage');
      } else {
        if (wasViewPage) {
          console.log('[UserList] created: from view page, keeping filters');
        } else if (isSamePage) {
          console.log('[UserList] created: from same page (refresh), keeping filters');
        }
      }
      sessionStorage.removeItem('peopleList_previousRoute');
    } else {
      // Si pas de previousRoute ou route vide, on peut supprimer les filtres
      // (sauf si c'est un premier chargement de la page)
      console.log('[UserList] created: no previousRoute found or empty, checking if should clear filters');
      // On ne supprime pas automatiquement ici car ça pourrait être un premier chargement
      // Les filtres seront supprimés seulement si on vient d'une autre page explicite
    }

    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    //this.$vs.loading()
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
    if (!modulePersonList.isRegistered) {
      this.$store.registerModule("peopleList", modulePersonList);
      modulePersonList.isRegistered = true;
    }
    this.$store.dispatch("peopleList/fetchPeople")
    .then((response) => {
      this.$vs.loading.close()
    })
    .catch((err) => {
      console.error(err);
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log('[UserList] beforeRouteLeave:', {
      from: from.path,
      to: to.path,
      hasGridApi: !!this.gridApi,
      isRestoringFilters: this.isRestoringFilters,
      hasRestoredFilters: this.hasRestoredFilters
    });

    // Sauvegarder les filtres avant de quitter
    // Forcer la sauvegarde même si hasRestoredFilters est false (cas où on quitte rapidement)
    if (this.gridApi) {
      // Temporairement permettre la sauvegarde
      const wasRestoring = this.isRestoringFilters;
      const hadRestored = this.hasRestoredFilters;
      this.isRestoringFilters = false;
      this.hasRestoredFilters = true;

      // Sauvegarder directement (sans setTimeout pour être sûr que ça se fait avant la navigation)
      // Récupérer le filterModel directement (ag-grid le met à jour automatiquement)
      const filterModel = this.gridApi.getFilterModel();
      const filterModelStr = JSON.stringify(filterModel);
      const currentPage = this.gridApi.paginationGetCurrentPage();

      console.log('[UserList] beforeRouteLeave: saving filters directly', {
        filterModel: filterModel,
        searchQuery: this.searchQuery,
        currentPage: currentPage,
        filterModelStr: filterModelStr,
        filterModelKeys: filterModel ? Object.keys(filterModel) : []
      });

      sessionStorage.setItem('peopleList_filterModel', filterModelStr);
      sessionStorage.setItem('peopleList_searchQuery', this.searchQuery || '');
      sessionStorage.setItem('peopleList_currentPage', currentPage.toString());

      // Restaurer les flags
      this.isRestoringFilters = wasRestoring;
      this.hasRestoredFilters = hadRestored;
    } else {
      console.log('[UserList] beforeRouteLeave: gridApi not available, cannot save');
    }

    // Ne JAMAIS supprimer les filtres quand on quitte la page
    // Ils seront supprimés seulement si on revient depuis une autre page (pas une View)
    next();
  },
  beforeRouteEnter(to, from, next) {
    // Stocker la route précédente pour vérifier dans created()
    // On sauvegarde toujours la route précédente, même si elle est vide
    console.log('[UserList] beforeRouteEnter:', {
      from: from.path,
      to: to.path
    });
    sessionStorage.setItem('peopleList_previousRoute', from.path || '');
    next();
  },
  beforeDestroy() {
    // Nettoyer l'event listener pour éviter les fuites mémoire
    if (this.gridApi && this.filterChangedListener) {
      this.gridApi.removeEventListener('filterChanged', this.filterChangedListener);
    }
  },
};
</script>

<style scoped>
@keyframes spin {
  to { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
